/* global axios */
import ApiClient from '../ApiClient';

class PilotPreferences extends ApiClient {
  constructor() {
    super('pilot/preferences', { accountScoped: true });
  }

  get() {
    return axios.get(this.url);
  }

  updatePreferences(data) {
    return axios.put(this.url, data);
  }
}

export default new PilotPreferences();
